import { render, staticRenderFns } from "./RutaMonitoringSkeleton.vue?vue&type=template&id=7d4afd56"
import script from "./RutaMonitoringSkeleton.vue?vue&type=script&lang=js"
export * from "./RutaMonitoringSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports